import { MatDialogRef } from '@angular/material/dialog';
import { Component } from '@angular/core';

@Component({
    selector: 'option-not-available',
    templateUrl: './option-not-available-dialog.component.html',
    styleUrls: [
        './option-not-available-dialog.component.css'
    ]
})
export class OptionNotAvailableDialogComponent {

    // Properties

    // Class Functions
    constructor(
        private dialogBox: MatDialogRef<OptionNotAvailableDialogComponent>
    ) {}

    // Event Functions
    ok() {
        // PRE: the ok button is clicked
        // POST: closes the dialog box
        this.dialogBox.close();
    }

    // Methods
}